// import { getCookie } from 'common/utils';

export const lclist = (state) => {
  if (state.initData && state.initData.dataAuth) {
    return state.initData.dataAuth.lclist;
  }
  return [];
};

// export const centerCity = (state) => {
//   const logisticsCenter = getCookie('logisticsCenter');
//   if (state.initData && state.initData.dataAuth && state.initData.dataAuth.lclist) {
//    const city = state.initData.dataAuth.lclist.find(c => c.id === parseInt(logisticsCenter, 10));
//     return city ? city.name : '';
//   }
//   return '';
// };

export const userInfo = (state) => {
  if (state.initData && state.initData.dataAuth) {
    return {
      chinesename: state.initData.dataAuth.chinesename,
      phone: state.initData.dataAuth.phone,
    };
  }
  return {};
};



// WEBPACK FOOTER //
// ./src/pages/homepage/store/getters.js